import React, { useEffect, useState, useCallback } from 'react';
import SideBar from '../../components/sidebar';
import NavBar from '../../components/NavBar';
import { FiEdit2 } from 'react-icons/fi';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { MdOutlineAdd } from 'react-icons/md';
import bgImg from '../../assets/images/Rectangle 5.svg';
import profileImg from '../../assets/images/296fe121-5dfa-43f4-98b5-db50019738a7.jpg';
import { useParams } from 'react-router-dom';
import EditStartupForm from '../startups/step/EditForm/EditStartupForm';
import EditAboutForm from '../startups/step/EditForm/EditAboutForm';
import AddAwardForm from '../startups/step/EditForm/AddAwardForm';
import EditTeamMembersForm from '../startups/step/EditForm/EditTeamMembersForm';
import toast from 'react-hot-toast';
import EditMentorForm from '../startups/step/EditForm/EditMentorForm';
import { ApiFetchStartup } from '../../API/API';



function StartupProfile() {
  
  const { official_email_address} = useParams();
   console.log("Param official_email_address:", official_email_address);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showAboutForm, setShowAboutForm] = useState(false);
  const [showAddAwardForm, setShowAddAwardForm] = useState(false);
  const [showTeamMembersForm, setShowTeamMembersForm] = useState(false);
  const [showMentorForm, setShowMentorForm] = useState(false);

  const [startupData, setStartupData] = useState(null);

  // Edit handlers
  const handleEditClick = () => setShowEditForm(true);
  const handleAboutClick = () => setShowAboutForm(true);
  
  const handleAddAwardClick = () => setShowAddAwardForm(true);
  const handleTeamMembersClick = () => setShowTeamMembersForm(true);
  
  const handleMentorEditClick = () => setShowMentorForm(true);

  const handleEditClose = async () => {
    await FetchData();
    setShowEditForm(false);
  }
const handleAboutClose = async () => {
  await FetchData();              
  setShowAboutForm(false);    
}   
  const handleAddAwardClose = () => setShowAddAwardForm(false);
  const handleTeamMembersClose = () => setShowTeamMembersForm(false);
  const handleMentorEditClose = async () =>{ 
    await FetchData()
    setShowMentorForm(false);
  }

  const handleEditSubmit = async (updatedData) => {
    // Here you would typically call your API to update the startup
    // await ApiUpdateStartup(id, updatedData);
    setStartupData(updatedData);
  };

  const handleAboutSubmit = async (updatedData) => {
    setStartupData(prev => ({
      ...prev,
      about: updatedData.about
    }));
  };

  const handleAddAwardSubmit = async (newAward) => {
    setStartupData(prev => ({
      ...prev,
      awards: [...prev.awards, newAward]
    }));
  };

  const handleTeamMembersSubmit = async (updatedData) => {
    setStartupData(prev => ({
      ...prev,
      founders: updatedData.founders,
      team_members: updatedData.team_members
    }));
    toast.success("Team members updated successfully");
  };

  const handleMentorEditSubmit = async (updatedData) => {
    setStartupData(prev => ({
      ...prev,
      mentor_associated: updatedData.mentor_associated,
      // Add any other fields you expect to update from the mentor form
    }));
    toast.success("Mentor details updated successfully");
  };

  const FetchData = useCallback(async () => {
    const API = await ApiFetchStartup();
    const allStartup = API?.rows || [];
    const selectedstartup = allStartup.find(
      (startup) => String(startup.email_address) === String(official_email_address)
    );
    console.log("Selected startup:", selectedstartup);
    setStartupData(selectedstartup || null);
  }, [official_email_address]);

   useEffect(() => {
      FetchData();
    }, [official_email_address, FetchData]);


    if (!startupData) {
      return <div>Loading startup details</div>
    }



  return (
    <div className="flex font-[\'DM Sans\',sans-serif]">
      <SideBar />
      <div className="ms-[221px] flex-grow">
        <NavBar />
        <div className="bg-[#F8FAFB] min-h-screen">
          <div className="mx-auto max-w-6xl py-6">
            {/* Display the id for confirmation */}
            <div className="mb-4 p-2 bg-yellow-100 text-yellow-800 rounded">Profile ID: {startupData?.id || official_email_address}</div>
            {/* Breadcrumb */}
            <div className="text-xs text-[#A1A1A1] mb-2 flex items-center gap-2">
              <span className="material-icons text-base">chevron_left</span>
              Dashboard &gt; Start-ups &gt; Profile
            </div>
            {/* Title */}
            <div className="font-semibold text-2xl mb-6 text-[#232323]">Start-up profile</div>
            {/* Top Profile Section */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              {/* Left: Profile Card */}
              <div className="relative bg-white rounded-2xl shadow p-0 flex flex-col min-h-[340px]">
                {/* Background image with edit icon */}
                <div className="relative h-[140px] rounded-t-2xl overflow-hidden">
                  <img src={startupData.background_image || bgImg} alt="bg" className="w-full h-full object-cover" />
                  <button 
                    onClick={handleEditClick}
                    className="absolute top-3 right-3 bg-white rounded-full p-2 shadow hover:bg-gray-100 transition"
                  >
                    <FiEdit2 size={18} className="text-[#232323]" />
                  </button>
                </div>
                {/* Profile image with green border */}
                <div className="absolute left-1/2 top-[90px] -translate-x-1/2 z-10">
                  <div className="w-24 h-24 rounded-full border-4 border-[#45C74D] bg-white flex items-center justify-center overflow-hidden">
                    <img src={startupData.logo_image || profileImg} alt="Startup Logo" className="w-22 h-22 rounded-full object-cover" />
                  </div>
                </div>
                {/* Card content */}
                <div className="flex flex-col items-center pt-20 pb-6 px-6">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-bold text-xl text-[#232323]">{startupData.startup_name}</span>
                    <span className="bg-[#E9F7F1] text-[#45C74D] text-xs font-semibold px-2 py-0.5 rounded ml-1">Active</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-[#232323] mb-1">
                    <span className="flex items-center gap-1"><span className="material-icons text-base">Email -</span> {startupData.email_address}</span>
                    
                    
                  </div>
                  <div className="flex items-center gap-2 text-sm text-[#232323] mb-2">
                    <span className="flex items-center gap-1"><span className="material-icons text-base">Call -</span> {startupData.founder_number}</span>
                    </div>
                      <div className="flex items-center gap-2 text-sm text-[#232323] mb-2">
                    <span className="flex items-center gap-1"><span className="material-icons text-base">linked In -</span> {startupData.linkedin}</span>
                  </div>
                  {/* Project Timeline */}
                  {/* <div className="w-full mt-2">
                    <div className="font-semibold text-sm text-[#232323] mb-1">Project Timeline</div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 h-2 bg-[#E9F7F1] rounded-full relative">
                        <div className="absolute left-0 top-0 h-2 bg-[#45C74D] rounded-full" style={{ width: '30%' }} />
                      </div>
                      <span className="text-xs text-[#45C74D] font-semibold ml-2">Step 01</span>
                    </div>
                    <div className="flex items-center justify-between mt-1">
                      <span className="text-xs text-[#A1A1A1]">Problem Validation</span>
                      <button className="bg-[#45C74D] text-white px-6 py-1 rounded-full text-sm font-semibold shadow hover:bg-[#36a03d] transition">View</button>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* Right: About Us & Awards (Figma accurate) */}
              <div className="flex flex-col gap-6">
                {/* About Us Card */}
                <div className="bg-white rounded-2xl shadow p-6 min-h-[180px] relative flex flex-col justify-between">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold text-lg text-[#232323]">About Us</span>
                    <button className="p-1 hover:bg-gray-100 rounded-full" onClick={handleAboutClick}>
                      <FiEdit2 size={18} className="text-[#A1A1A1]" />
                    </button>
                  </div>
                  <div className="text-[#232323] text-sm mb-4">{startupData.startup_description}
                  </div>
                  <div className="flex w-full gap-4 text-sm font-medium text-[#232323]">
                    <div className="flex-1">
                      <div className="text-[#A1A1A1] text-xs mb-1">Start-up Type</div>
                      <div>{startupData.startup_type}</div>
                    </div>
                    <div className="flex-1">
                      <div className="text-[#A1A1A1] text-xs mb-1">Sector</div>
                      <div>{startupData.startup_sector}</div>
                    </div>
                    <div className="flex-1">
                      <div className="text-[#A1A1A1] text-xs mb-1">Program</div>
                      <div>{startupData.program}</div>
                    </div>
                  </div>
                </div>
                {/* Awards & Recognitions Card */}
                <div className="bg-white rounded-2xl shadow p-6 min-h-[180px] relative flex flex-col justify-between">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold text-lg text-[#232323]">Awards & Recognitions</span>
                    <div className="flex items-center gap-2">
                      <button className="p-1 hover:bg-gray-100 rounded-full" onClick={handleAddAwardClick}>
                        <MdOutlineAdd size={22} className="text-[#45C74D]" />
                      </button>
                    </div>
                  </div>
                  {/* Award List */}
                  <div className="flex flex-col gap-3 mt-2">
                    <div className="flex items-start gap-2">
                      <span className="mt-1 w-2 h-2 bg-[#232323] rounded-full inline-block" />
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <span className="font-semibold text-sm text-[#232323]">Award/ Recognition Name</span>
                          <button className="p-1 hover:bg-gray-100 rounded-full"><FiEdit2 size={16} className="text-[#A1A1A1]" /></button>
                        </div>
                        <div className="text-xs text-[#232323]">Award/ Recognition Org - Awarded date</div>
                        <div className="text-xs text-[#A1A1A1] mb-1">Description</div>
                        <div className="inline-flex items-center gap-2 bg-[#F8FAFB] rounded-lg px-3 py-1 mt-1 border border-[#E6E6E6]">
                          <img src="/src/assets/images/Frame (8).svg" alt="PDF" className="w-5 h-5" />
                          <span className="text-xs text-[#232323] font-medium truncate max-w-[120px]">Document Name.pdf</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Details Grid Section */}
            <div className="bg-white rounded-2xl shadow p-6 mb-8 grid grid-cols-3 gap-8 text-sm font-medium text-[#232323] relative">
              {/* Edit button at top right */}
              <button
                className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded"
                onClick={handleMentorEditClick}
                title="Edit Mentor & Details"
              >
                <FiEdit2 size={20} className="text-[#45C74D]" />
              </button>
              <div>
                <div className="flex items-center gap-1 mb-1 font-semibold">Mentors</div>
                <div className="text-[#A1A1A1]">{startupData.mentor_associated || 'N/A'}</div>
                <div className="mt-6 font-semibold">CIN/ Registration Number</div>
                <div className="text-[#A1A1A1]">{startupData.cin_registration_number || 'N/A'}</div>
                <div className="mt-6 font-semibold">Year of Graduation</div>
                <div className="text-[#A1A1A1]">{startupData.startup_yog || 'N/A'}</div>
                <div className="mt-6 font-semibold">Current Funding State</div>
                <div className="text-[#A1A1A1]">{startupData.startup || 'N/A'}</div>
                <div className="mt-6 font-semibold">Current Funding State</div>
                <div className="text-[#A1A1A1]">{ startupData.funding_stage || 'N/A'}</div>
              </div>
              <div>
                <div className="flex items-center gap-1 mb-1 font-semibold">Role of Faculty </div>
                <div className="text-[#A1A1A1]">{startupData.role_of_faculty || 'N/A'}</div>
                <div className="mt-6 font-semibold">Industry</div>
                <div className="text-[#A1A1A1]">{startupData.startup_industry || 'N/A'}</div>
                <div className="mt-6 font-semibold">Graduated To </div>
                <div className="text-[#A1A1A1]">{startupData.graduated_to || 'N/A'}</div>
                <div className="mt-6 font-semibold">Officially Registered as</div>
                <div className="text-[#A1A1A1]">{startupData.register || 'N/A'}</div>
                <div className="mt-6 font-semibold">Community</div>
                <div className="text-[#A1A1A1]">{startupData.startup_community || 'N/A'}</div>
              </div>
              <div>
                <div className="font-semibold mb-1">Cohort( Name & Year )</div>
                <div className="text-[#A1A1A1]">{startupData.startup_cohort || 'N/A'}</div>
                <div className="mt-6 font-semibold">Technology</div>
                <div className="text-[#A1A1A1]">{startupData.startup_technology || 'N/A'}</div>
                <div className="mt-6 font-semibold">DPIIT Number</div>
                <div className="text-[#A1A1A1]">{startupData.dpiit || 'N/A'}</div>
                <div className="mt-6 font-semibold">PIA</div>
                <div className="text-[#A1A1A1]">{startupData.pia_state || 'N/A'}</div>
                <div className="mt-6 font-semibold">Academic Background</div>
                <div className="text-[#A1A1A1]">{startupData.academic_background || 'N/A'}</div>
              </div>
            </div>

            {/* Founders Section */}
            <div className="bg-white rounded-2xl shadow p-6 mb-8">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-4">
                  <span className="font-bold text-lg text-[#45C74D]">Founders</span>
                  {/* <span className="font-semibold text-lg text-[#A1A1A1]">Team Members</span> */}
                </div>
                <div className="flex items-center gap-2">
                  <button className="p-1 hover:bg-gray-100 rounded-full" onClick={handleTeamMembersClick}>
                    <FiEdit2 size={22} className="text-[#45C74D]" />
                  </button>
                  <button className="p-1 hover:bg-gray-100 rounded-full"><BsThreeDotsVertical size={22} className="text-[#A1A1A1]" /></button>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                {/* Founder 1 */}
                <div className="flex items-center gap-4">
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Founder" className="w-14 h-14 rounded-lg object-cover" />
                  <div className="flex-1">
                    <div className="font-semibold text-base">{startupData.founder_name}</div>
                    <div className="text-sm text-[#A1A1A1]">{startupData.founder_email}</div>
                    <div className="text-sm text-[#A1A1A1]">{startupData.founder_number}</div>
                  </div>
                  <button className="p-1 hover:bg-gray-100 rounded-full"><BsThreeDotsVertical size={20} className="text-[#A1A1A1]" /></button>
                </div>
                {/* Founder 2 */}
                {/* <div className="flex items-center gap-4">
                  <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Founder" className="w-14 h-14 rounded-lg object-cover" />
                  <div className="flex-1">
                    <div className="font-semibold text-base">Name (Role)</div>
                    <div className="text-sm text-[#A1A1A1]">ed19b063@smail.iitm.ac.in  |  +91 98400 46978</div>
                    <div className="text-sm text-[#A1A1A1]">Linked in</div>
                  </div>
                  <button className="p-1 hover:bg-gray-100 rounded-full"><BsThreeDotsVertical size={20} className="text-[#A1A1A1]" /></button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showEditForm && (
        <EditStartupForm
          initialData={startupData}
          onClose={handleEditClose}
          onSubmit={handleEditSubmit}
        />
      )}
      {showAboutForm && (
        <EditAboutForm
          initialData={startupData}
          onClose={handleAboutClose}
          onSubmit={handleAboutSubmit}
        />
      )}
      {showAddAwardForm && (
        <AddAwardForm
          initialData={{}}
          onClose={handleAddAwardClose}
          onSubmit={handleAddAwardSubmit}
        />
      )}
      {showTeamMembersForm && (
        <EditTeamMembersForm
          initialData={startupData}
          onClose={handleTeamMembersClose}
          onSubmit={handleTeamMembersSubmit}
        />
      )}
      
      {showMentorForm && (
        <EditMentorForm
          initialData={startupData}
          onClose={handleMentorEditClose}
          onSubmit={handleMentorEditSubmit}
        />
      )}
    </div>
  );
}

export default StartupProfile;